import { Box, FormikCheckboxInput } from '@palmetto/palmetto-components';
import { Field, useFormikContext } from 'formik';

import { ProgramType } from 'types';

export const EnergyBackupOptions = ({ programType }: { programType: ProgramType }) => {
  const { values } = useFormikContext<any>();

  if (programType !== ProgramType.energyBackup) {
    return null;
  }
  return (
    <Box childGap="xl" radius="md" borderWidth="xs" borderColor="separator" padding="lg">
      <Box as="h3" fontWeight="medium" fontSize="md">
        Energy Backup Options
      </Box>

      <Box direction={{ desktop: 'row', base: 'column' }} childGap={{ desktop: '4xl', base: 'xl' }} wrap>
        <Field
          label="Arbitrage Battery"
          name="energyBackupOptions.arbitrageBattery"
          id="energyBackupOptions.arbitrageBattery"
          component={FormikCheckboxInput}
          isChecked={values?.energyBackupOptions?.arbitrageBattery}
        />
        <Field
          label="Backup Battery"
          name="energyBackupOptions.backupBattery"
          id="energyBackupOptions.backupBattery"
          component={FormikCheckboxInput}
          isChecked={values?.energyBackupOptions?.backupBattery}
        />
      </Box>
    </Box>
  );
};
